import { React, useLayoutEffect} from 'react'
import { Button } from '../ButtonElements';
import { useNavigate } from 'react-router-dom';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/all';

import photo from '../../images/cardapio_alpha.jpg';
import { useTranslation } from 'react-i18next';

import { 
    WrapperCardapio,
    FotoCardapio,
    PhotoCardapio,
    InfosCardapio,
    TitleCardapio,
 } from './CardapioElements';


const CardapioSection = () => {
    let nav = useNavigate();

    const { t } = useTranslation(); 

    
    useLayoutEffect(() => {
        gsap.registerPlugin(ScrollTrigger);
        gsap.to("#cardapio", {
            opacity: 1,
            scrollTrigger:{
                trigger: "#cardapio",
                start: "top 90%",
                end: "bottom 150%",
                scrub: true,
                // markers: true,
            }
        })
        return() => {
            gsap.killTweensOf("#cardapio");
        }
    }, [])
  
  
    return (
    
    <>
        <WrapperCardapio id='cardapio'>
            <FotoCardapio>
                <PhotoCardapio src={photo} />
            </FotoCardapio>

            <InfosCardapio>
                <TitleCardapio id='markerTrigger'>{t('menu.title')}</TitleCardapio>
                <Button onClick={() => {nav("/cardapio")}}>{t('menu.button')}</Button>
            </InfosCardapio>
        </WrapperCardapio>
      
    </>
  )
}

export default CardapioSection
